
import SmartSearchOverlay from './SmartSearchOverlay';


(function() {
  const html = document.querySelector('html');
  const overlay = document.getElementById('smart-search-overlay');
  const openModal = document.getElementById('smart-search-button');
  const closeModal = document.getElementById('smart-search-close');
  const page = document.querySelector('.document-wrap');
  const overlayWrapper = document.querySelector('.smart-search-wrapper');
  
  let s = new SmartSearchOverlay();
  let modalOpen = false;    
  let lastFocus;

  // check to see if smart search button exists 
  if ( !openModal ) {
    return;
  }

  // Open the modal
  function modalShow () {
    lastFocus = document.activeElement;
    page.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'false');
    modalOpen = true;

    setTimeout(() => {
      overlay.querySelector('#searchbox form input').setAttribute('tabindex', '0');
      overlay.querySelector('#searchbox form input').focus();
    }, 300); // wait for algolia to init

    html.classList.add( 'ncstate-utility-bar-lock-scroll' );

    if ( s && !s.search.started ) {
      s.init();
    }
  }


  // binds to both the button click and the escape key to close the modal window
  // but only if modalOpen is set to true
  function modalClose ( event ) {
    if (modalOpen && ( !event.keyCode || event.keyCode === 27 ) ) {
      overlay.setAttribute('aria-hidden', 'true');
      page.setAttribute('aria-hidden', 'false');
      overlayWrapper.setAttribute('tabindex', '-1');
      modalOpen = false;
      lastFocus.focus();

			html.classList.remove( 'ncstate-utility-bar-lock-scroll' );
    }
  }

  // Restrict focus to the modal window when it's open.
  // Tabbing will just loop through the whole modal.
  function focusRestrict ( event ) {
    document.addEventListener('focus', function( event ) {

      if (event.keyCode == 9) {
        console.log(modalOpen)
      }
      
      if ( modalOpen && !overlay.contains( event.target ) ) {
        event.stopPropagation();
        overlay.querySelector('#searchbox form input').focus();
      }
    }, true);
  }

  // Close modal window 
  overlay.addEventListener('click', function( e ) {
    if (e.target == overlayWrapper.parentNode) {
      modalClose( e );
    }
  }, false);


  openModal.addEventListener('click', modalShow);
  closeModal.addEventListener('click', modalClose);
  document.addEventListener('keydown', modalClose);
  window.addEventListener('keydown', focusRestrict);

})();
